import { Box } from "@mui/material";
import { Pet } from "../../../types";
import Card from "../../../components/card/card";
import { PetCardStyled, PetsListStyled, AddPetButtonStyled } from "./pets.styles";
import { useContext, useRef } from "react";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";
import Skeleton from "../../../../../components/skeleton/skeleton";
import { getAge, isSomething } from "../../../../../utils/common-utils";
import useFetchPets from "./pets.hook";

const PetsList = ({
  arePetsExist,
  petsList,
}: {
  arePetsExist?: boolean;
  petsList?: any[];
}) => {
  const boxRef = useRef<any>(null);
  const {
    state: { selectedPets, activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const { pets, loading } = useFetchPets();

  const togglePetSelection = (pet: Pet) => {
    const updatedPets = selectedPets.some((p) => p.id === pet.id)
      ? selectedPets.filter((p) => p.id !== pet.id)
      : [...selectedPets, pet];

    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_PETS,
      payload: updatedPets,
    });
  };

  const finalList = petsList || pets;

  return (
    <Card
      ref={boxRef}
      title={"Choose pets"}
      description={"Choose pets from the list to continue your booking process"}
      btnTitle={"Continue"}
      onHandleClick={() =>
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: arePetsExist ? activeStep + 3 : activeStep + 1,
        })
      }
      progress={activeStep * 5}
      disabledConfirmBtn={selectedPets.length === 0}
      customCta={
        <AddPetButtonStyled
          className="add-pet-btn"
          variant="outlined"
          onClick={() => {
            userDispatcher({
              type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_PETS,
              payload: [],
            });
            userDispatcher({
              type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
              payload: 11,
            });
          }}
        >
          Add New Pet
        </AddPetButtonStyled>
      }
      showBackButton
      handleBack={() =>
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep - 1,
        })
      }
      hideDescription
    >
      <PetsListStyled>
        {(finalList?.length === 0 || loading) && (
          <>
            {[...Array(3)].map((_, index) => (
              <Skeleton key={index} height={100} />
            ))}
          </>
        )}
        {isSomething(finalList) &&
          !loading &&
          finalList?.map((pet: any) => (
            <PetCardStyled
              key={pet.id}
              className={
                selectedPets.some((p: any) => p.id === pet.id)
                  ? "isSelected"
                  : ""
              }
              onClick={() => togglePetSelection(pet)}
            >
              <Box className="row">
                <Box>
                  <Box className="label">Name</Box>
                  <Box className="value">{pet.name}</Box>
                </Box>
                <Box>
                  <Box className="label">Species</Box>
                  <Box className="value">{pet.species[0]?.label}</Box>
                </Box>
                <Box>
                  <Box className="label">Gender</Box>
                  <Box className="value">{pet?.genders?.[0]?.label}</Box>
                </Box>
                <Box>
                  <Box className="label">Breed</Box>
                  <Box className="value">{pet?.breeds?.[0]?.label}</Box>
                </Box>
                <Box>
                  <Box className="label">Age</Box>
                  <Box className="value">{getAge(pet.birthdate)}</Box>
                </Box>
              </Box>
            </PetCardStyled>
          ))}
      </PetsListStyled>
    </Card>
  );
};

export default PetsList;
